import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getCustomerAddresses } from "../../api/apiCustomers";

export const useGetCustomerAddresses = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["customer-addresses", id, i18next.language],
        queryFn: () => getCustomerAddresses(id),
        enabled: !!id,
    });

    const root = data?.data;
    const addresses = Array.isArray(root) ? root : (Array.isArray(root?.data) ? root.data : []);

    return { isLoading, error, addresses, refetch };
};
